import { BaseThunk } from 'components/base/base-thunk';
import { TransportTaskService } from '../service';
import { RootState } from 'store';
import moment from 'moment';
import { ALl_STATUS, FORMAT_DATETIME } from 'utils/constants';

const transportTaskService = new TransportTaskService();

const transportTaskThunkManager = new BaseThunk<ITransportTaskTable>(transportTaskService);

/**
 * Async thunk for fetching a paginated list of transport tasks with optional search and sorting.
 **/
export const getAllTransportThunk = transportTaskThunkManager.getAll<
    ResponseBase<ITransportTaskTable[]>,
    ICollectionSearch | undefined
>('transportTask/getAll', (params, thunkAPI) => {
    const state = thunkAPI.getState() as RootState;
    const transportTaskState = state.transportTask;
    const paginateMetaData = transportTaskState.paginateMetaData;

    const filter = params
        ? Object.entries(params).reduce<ITransportSearch>((acc, [key, value]) => {
              if (key === 'status' && value !== null && value !== undefined && value !== '') {
                  acc[key] = [value.toString()];
              } else if (
                  (value !== null && value !== undefined && value !== '') ||
                  key === 'delete_at'
              ) {
                  acc[key as keyof ITransportSearch] =
                      key.includes('planned_date_from') || key.includes('planned_date_to')
                          ? moment.utc(value).format(FORMAT_DATETIME.YYYYMMDD2)
                          : value;
              }
              return acc;
          }, {})
        : {};

    const hasOtherKeys = Object.keys(filter).some((key) => key !== 'delete_at');
    const hasStatus = 'status' in filter;

    if (hasOtherKeys && !hasStatus) {
        filter.status = ALl_STATUS;
    } else if (!filter.hasOwnProperty('status')) {
        filter.status = ['1'];
    }

    if (
        filter.status &&
        Array.isArray(filter.status) &&
        filter.status.length === 1 &&
        filter.status[0].includes(',')
    ) {
        filter.status = filter.status[0].split(',');
    }

    const sort = `${transportTaskState.sort?.fieldName}:${transportTaskState.sort?.ascending ? 'asc' : 'desc'}`;

    const request: TransportTaskRequest = {
        page: paginateMetaData.page,
        per_page: paginateMetaData.per_page,
        filter: JSON.stringify(filter),
        ...(transportTaskState.sort?.fieldName ? { sort } : {}),
    };

    return request;
});

/**
 * Async thunk to fetch detailed transport task data by task ID.
 **/
export const getDetailListTransportThunk =
    transportTaskThunkManager.getById<any>('transportTask/getDetail');
